import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import { reportsApi, exportTdsFreightListExcel } from "../../Services/Services";
import { Select, Col, Input, Button, Form, message } from "antd"; // Import DatePicker
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import InfiniteScroll from "react-infinite-scroll-component";
import * as XLSX from "xlsx";
import { debounce } from "../util.js";

const { Option } = Select;
export default function TdsFreightList() {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [limit] = useState(50);
  const [form] = Form.useForm();
  const [exportLoading, setExportLoading] = useState(false);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [month, setMonth] = useState(new Date().getMonth() + 1);

  const [filters, setFilters] = useState({
    year: currentYear,
    month,
    truck_owner_name: "",
    do_no: "",
    vehicle_no: "",
  });

  // Debounced API call
  const debouncedFetch = useRef(
    debounce((appliedFilters, resetOffset = true) => {
      if (resetOffset) setOffset(0);
      setDeliveryOrder([]);
      setHasMore(true);
      fetchData(0, appliedFilters);
    }, 800)
  ).current;

  useEffect(() => {
    fetchData(0, filters);
  }, []);

  const fetchData = async (offset = 0, appliedFilters) => {
    const response = await reportsApi({
      report_name: "tds_freight_list",
      com_name: localStorage.getItem("com_name"),
      limit,
      offset,
      year: appliedFilters.year,
      month: appliedFilters.month,
      truck_owner_name: appliedFilters.truck_owner_name,
      do_no: appliedFilters.do_no,
      vehicle_no: appliedFilters.vehicle_no,
    });

    const data = response && response.results ? response.results : [];

    if (offset === 0) {
      setDeliveryOrder(data);
      setOrderList(data);
    } else {
      setDeliveryOrder((prev) => [...prev, ...data]);
      setOrderList((prev) => [...prev, ...data]);
    }

    if (data.length < limit) setHasMore(false);
    else setHasMore(true);
  };

  const fetchMoreData = () => {
    const newOffset = offset + limit;
    setOffset(newOffset);
    fetchData(newOffset, filters);
  };

  // Filter change handler
  const handleFilterChange = (key, value) => {
    const updatedFilters = { ...filters, [key]: value };
    setFilters(updatedFilters);
    debouncedFetch(updatedFilters);
  };

  const handleExportToExcel = async () => {
    try {
      setExportLoading(true);

      // Show loading message
      message.loading({
        content: "Generating Excel file...",
        key: "export",
        duration: 0,
      });

      // Call export API
      const response = await exportTdsFreightListExcel({
        com_name: localStorage.getItem("com_name"),
        year: filters.year,
        month: filters.month,
        truck_owner_name: filters.truck_owner_name,
        do_no: filters.do_no,
        vehicle_no: filters.vehicle_no,
      });

      if (!response.success) {
        throw new Error(response.error || "Failed to export Excel file");
      }

      // Generate filename
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const monthName = monthNames[filters.month - 1];
      const filename = `TDS_Freight_List_${monthName}_${filters.year}.xlsx`;

      // Download file
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      // Show success message
      message.success({
        content: "Excel file downloaded successfully!",
        key: "export",
        duration: 2,
      });
    } catch (error) {
      console.error("Export error:", error);

      // Show error message
      message.error({
        content: `Export failed: ${error.message || "Unknown error"}`,
        key: "export",
        duration: 3,
      });
    } finally {
      setExportLoading(false);
    }
  };

  const formateDate = (date) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  return (
    <div>
      {/* <Header heading="TODAY ORDER VIEW" /> */}
      <Form form={form} layout="vertical">
        <div
          className=" grid grid-cols-1 sm:grid sm:grid-cols-6 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]"
        >
          <Col>
            <label>
              <b>Select Year</b>
            </label>
            <br />
            <Select
              value={selectedYear}
              onChange={(value) => {
                setSelectedYear(value);
                handleFilterChange("year", value);
              }}
              style={{ width: "100%" }}
            >
              {Array.from(
                { length: currentYear - 2022 },
                (_, i) => 2023 + i
              ).map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Col>
          <Col>
            <label>
              <b>Select Month</b>
            </label>
            <br />
            <Select
              value={month}
              onChange={(value) => {
                setMonth(value);
                handleFilterChange("month", value);
              }}
              style={{ width: "100%" }}
            >
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((m, index) => (
                <Option key={index + 1} value={index + 1}>
                  {m}
                </Option>
              ))}
            </Select>
          </Col>
          <Col>
            <label>
              <b> Truck Owner Name</b>
            </label>
            <br />
            <Form.Item name="truck_owner_name">
              <Input
                placeholder="Search by Truck Owner Name"
                value={filters.truck_owner_name}
                onChange={(e) =>
                  handleFilterChange("truck_owner_name", e.target.value)
                }
              />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b> Search By Do Number</b>
            </label>
            <br />
            <Form.Item name="do_no">
              <Input
                placeholder="Search by DO Number"
                value={filters.do_no}
                onChange={(e) => handleFilterChange("do_no", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b> Search By Vehicle No</b>
            </label>
            <br />
            <Form.Item name="vehicle_no">
              <Input
                placeholder="Search by Vehicle No"
                value={filters.vehicle_no}
                onChange={(e) =>
                  handleFilterChange("vehicle_no", e.target.value)
                }
              />
            </Form.Item>
          </Col>
          <Col>
            <Button
              style={{
                bottom: "-10px",
                margin: "10px",
                backgroundColor: "black",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handlePrint}
            >
              <FaFilePdf />
            </Button>
            <Button
              style={{
                bottom: "-10px",
                margin: "10px",
                backgroundColor: "green",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handleExportToExcel}
            >
              <FaFileExcel />
            </Button>
          </Col>
        </div>
      </Form>
      <div
        style={{
          maxHeight: deliveryOrder.length > 0 ? "500px" : "100px",
          overflowY: deliveryOrder.length > 0 ? "auto" : "visible",
        }}
        ref={componentRef}
        id="scrollableDiv"
      >
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th>Sr. No</th>
              <th>Id</th>
              <th>Do No</th>
              <th>Truck Owner Name</th>
              <th>Vehicle No</th>
              <th>Dipatch Qty</th>
              <th>Recieved Qty</th>
              <th>Freight Qty</th>
              <th>Sort Qty</th>
              <th>Moisture %</th>
              <th>Actual Qty</th>
              <th>Moisture Deduct Qty</th>
              <th>Moisture Amt</th>
              <th>Moisture Deduct</th>
              <th>Sort Amount</th>
              <th>Freight Rate</th>
              <th>Freight Amt</th>
              <th>Tds %</th>
              <th>Tds Amt</th>
              <th>Advance Amt</th>
              <th>Commision Amt</th>
              <th>Pay Amt</th>
              <th>Dispatch Date</th>
              <th>Received Date</th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.length === 0 ? (
              <tr style={{ height: "30px" }}>
                {" "}
                <td
                  colSpan={24}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "4px 6px",
                  }}
                >
                  No data available
                </td>
              </tr>
            ) : (
              deliveryOrder.map((e, index) => (
                <tr key={e.id}>
                  <td>{index + 1}</td>
                  <td>{e.id}</td>
                  <td>
                    <Link to={`/do-view/${e.do_id}`}>
                      <u style={{ fontWeight: "600", color: "blue" }}>
                        {e.do_no}
                      </u>
                    </Link>
                  </td>
                  <td>{e.truck_owner_name}</td>
                  <td>{e.vehicle_no}</td>
                  <td>{e.dispatch_quantity.toFixed(3)}</td>
                  <td>{e.received_quantity.toFixed(3)}</td>
                  <td>{e.freight_quantity.toFixed(3)}</td>
                  <td>{e.sort_quantity}</td>
                  <td>{e.moisture_received_per}</td>
                  <td>{e.actual_quantity}</td>
                  <td>{e.moisture_deduct_quantity}</td>
                  <td>{e.moisture_amount}</td>
                  <td>{e.moisture_deduct}</td>
                  <td>{e.sort_amount}</td>
                  <td>{e.freight_rate}</td>
                  <td>{e.freight_amount}</td>
                  <td>{e.tds_per}</td>
                  <td>{e.tds}</td>
                  <td>{e.advance}</td>
                  <td>{e.commision}</td>
                  <td>{e.pay_amount}</td>
                  <td>{formateDate(e.date)}</td>
                  <td>{formateDate(e.received_date)}</td>
                </tr>
              ))
            )}
            <tr style={{ backgroundColor: "#e9e9e9", lineHeight: "1.2" }}>
              <td
                colSpan={5}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: "4px 6px",
                  fontSize: "12px",
                }}
              >
                Total
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.dispatch_quantity, 0)
                  .toFixed(3)}
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.received_quantity, 0)
                  .toFixed(3)}
              </td>
              <td colSpan={5} style={{ padding: "4px 6px" }}></td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.moisture_amount, 0)
                  .toFixed(2)}
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.moisture_deduct, 0)
                  .toFixed(2)}
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.sort_amount, 0)
                  .toFixed(2)}
              </td>
              <td style={{ padding: "4px 6px" }}></td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.freight_amount, 0)
                  .toFixed(2)}
              </td>
              <td style={{ padding: "4px 6px" }}></td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.tds, 0)
                  .toFixed(2)}
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.advance, 0)
                  .toFixed(2)}
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.commision, 0)
                  .toFixed(2)}
              </td>
              <td
                style={{
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {deliveryOrder
                  .reduce((acc, cur) => acc + +cur.pay_amount, 0)
                  .toFixed(2)}
              </td>
              <td colSpan={2} style={{ padding: "4px 6px" }}></td>
            </tr>
          </tbody>
        </table>
        <InfiniteScroll
          dataLength={deliveryOrder.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            deliveryOrder.length > 0 && hasMore ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                Loading...
              </div>
            ) : null
          }
          scrollableTarget="scrollableDiv"
        />
      </div>
      {/* <Footer /> */}
    </div>
  );
}
